export default __webpack_public_path__ + "img/file-gif.402d5c43.svg";